var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _path7, _rect6, _rect7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#93C9FF",
    d: "M0 0H170V170H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 47.3491L70 83.3491V155.349L7 119.349V47.3491Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132 47.3491L70 83.3491V155.349L132 119.349V47.3491Z",
    fill: "#fff",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 47.0767L69.1715 10.9131L132 47.0767L70 83.5001L7 47.0767Z",
    fill: "#fff",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8286 63.6636L98.0001 27.5L132 47.0762L70.0002 83.4996L35.8286 63.6636Z",
    fill: "#fff",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61L93.5 25L103.781 30.8363L41.7811 67.2597L31 61Z",
    fill: "#2B0EAF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 81.349,
    width: 61,
    height: 82,
    rx: 12,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 75.349,
    width: 25,
    height: 12,
    rx: 6,
    fill: "#E62048"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 96.349,
    width: 15,
    height: 16,
    rx: 4,
    fill: "#C5E5FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 116.349,
    width: 15,
    height: 15,
    rx: 4,
    fill: "#C5E5FB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 135.349,
    width: 15,
    height: 15,
    rx: 4,
    fill: "#C5E5FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.106 109.349C119.798 109.35 119.492 109.286 119.207 109.161C118.922 109.036 118.664 108.853 118.446 108.622L114.688 104.654C114.47 104.423 114.297 104.149 114.179 103.848C114.061 103.546 114 103.223 114 102.897C114 102.571 114.061 102.248 114.179 101.946C114.297 101.645 114.47 101.371 114.688 101.14C114.907 100.909 115.166 100.726 115.451 100.601C115.736 100.477 116.041 100.412 116.35 100.412C116.659 100.412 116.964 100.477 117.249 100.601C117.534 100.726 117.793 100.909 118.012 101.14L120.107 103.353L126.988 96.0769C127.207 95.8461 127.466 95.6631 127.751 95.5383C128.036 95.4134 128.341 95.3491 128.65 95.3491C128.959 95.3491 129.264 95.4134 129.549 95.5383C129.834 95.6631 130.093 95.8461 130.312 96.0769C130.53 96.3076 130.703 96.5815 130.821 96.883C130.939 97.1844 131 97.5075 131 97.8338C131 98.1601 130.939 98.4832 130.821 98.7847C130.703 99.0861 130.53 99.3601 130.312 99.5908L121.768 108.624C121.55 108.855 121.291 109.037 121.006 109.162C120.721 109.286 120.415 109.35 120.106 109.349Z",
    fill: "#2255EF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 113.783,
    y: 136.818,
    width: 5,
    height: 15.75,
    rx: 2.5,
    transform: "rotate(-45 113.783 136.818)",
    fill: "#E62048"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 15.75,
    rx: 2.5,
    transform: "scale(-1 1) rotate(-45 100.926 223.469)",
    fill: "#E62048"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5E5FB",
    d: "M131 121H155V127H131zM131 102H155V108H131zM131 140H155V146H131z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61L42 67V86L36.5 78L31 80V61Z",
    fill: "#2255EF"
  })));
}

export default SvgStep9;